module.exports = __webpack_public_path__ + "static/media/389094_2_0.6525b583.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/helpers/webfonts/389094_2_0.woff
// module id = 726
// module chunks = 0